// extracted by mini-css-extract-plugin
export default {"container":"bio_container__2qTkQ","name":"bio_name__29N-f","email":"bio_email__2AGRY","body":"bio_body__HOSgS","linkedin":"bio_linkedin__3xU3C","image":"bio_image__6T06b"};